import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { APP_SETTINGS, ToastConfigService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { CmsNavbarService } from '../../cms-navbar/cms-navbar.service';
import { ModelMapService } from '../../model-map/model-map.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { AdminService } from '../admin.service';
// import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { NgForm, FormsModule } from '@angular/forms';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BMWListData } from '../../../core/models/bmwListData';
import { FindAllScopePatternNumberListRequest } from '../../../core/models/findAllScopePatternNumberListRequest';
import { FindAllScopePatternNumberListResponse } from '../../../core/models/findAllScopePatternNumberListResponse';
import { FindOneScopePatternNumberRequest } from '../../../core/models/findOneScopePatternNumberRequest';
import { FindOneScopePatternNumberResponse } from '../../../core/models/findOneScopePatternNumberResponse';
import { MINIListData } from '../../../core/models/miniListData';
import { MOTORRADListData } from '../../../core/models/motorradListData';
import { ResultStatus } from '../../../core/models/resultStatus';
import { ROLLSROYCEListData } from '../../../core/models/rollsRoyceListdata';
import { ScopePatternData } from '../../../core/models/scopePatternData';
import { ScopePatternNumbersList } from '../../../core/models/scopePatternNumbersList';
import { ScopePatternParamsRefDataResponse } from '../../../core/models/scopePatternParamsRefDataResponse';
import { UpdateExistingScopePatternRequest } from '../../../core/models/updateExistingScopePatternRequest';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { DialogService } from '../../../core/services/dialog/dialog.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { ScopePatternService } from '../../scope-pattern/scope-pattern.service';
import { NgIf, NgFor, NgStyle } from '@angular/common';
import { SelectRequiredValidatorDirective } from '../../../shared/directives/select-required-validator.directive';

declare var $: any;
@Component({
    selector: 'app-edit-bulletin-for-scope-pattern-component',
    templateUrl: './edit-bulletin-for-scope-pattern-component.component.html',
    styleUrls: ['./edit-bulletin-for-scope-pattern-component.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        NgIf,
        SelectRequiredValidatorDirective,
        NgFor,
        NgStyle,
        NgMultiSelectDropDownModule,
    ],
})
export class EditBulletinForScopePatternComponentComponent implements OnInit, OnDestroy {

  public bulletinType = '';
  public actionType = '';
  private subscriptions: ISubscription[] = [];
  public makeList;
  public inputMake;
  public inputDate: string;
  public selDate;
  public tkrCode = '';
  public isTakataRecall = false;
  public documentNumber = '';
  public bulletinNumber = '';
  public textareaContent = '';
  public relatedSIBs: string[] = [];
  public setDateFlag: boolean = false;
  public splDocumentName: string;

  //public reactivateOrDeactivate: any;

  public reactivate = false;
  public deactivate = false;
  public isDocActive = false;
  public makeNameForApi: string;
  //  public listMakeName: ParamListItem[];

  public inputSeries = '';
  public inputModel = '';
  public inputEngine = '';

  public inputArea = '';

  public inputChannel: any;

  public scopePatternNumber: any;

  public channelsList = [];

  public seriesList: any[];
  public seriesFilterList: any[];


  public areaList: any[];
  public areaFilterList: string[];
  public scopePatternParamsRefDataResponse: ScopePatternParamsRefDataResponse;

  findAllScopePatternNumberListRequest?= new FindAllScopePatternNumberListRequest();
  findAllScopePatternNumberListResponse?= new FindAllScopePatternNumberListResponse();

  findOneScopePatternNumberRequest?= new FindOneScopePatternNumberRequest();
  findOneScopePatternNumberResponse?= new FindOneScopePatternNumberResponse();

  updateExistingScopePatternRequest?= new UpdateExistingScopePatternRequest();
  UpdateExistingScopePatternResponse?= new UpdateExistingScopePatternRequest();

  public documentNumbersList: any[];
  public ScopePatternNumbersList: ScopePatternNumbersList[];
  public scopePatternData: ScopePatternData;
  public obdCategories: any[];
  public docId: number;

  private userEmail: string;

  public errorMessage = '';
  public errorMessageSIB = '';
  public showAllFields: boolean = false;

  public uploadedFileName = 'No File Selected';
  public vimeoID = '';
  public uploadedFile = null;

  public pageTitle: string;

  public allObdData: any[];
  public documentOBDTitle;

  public newUploadFlag: boolean = false;
  public showAllOptionsOBD: boolean = false;
  public showAllOptionsTool: boolean = false;

  public isMotorradAdmin: boolean = false;
  public isRollsRoyceAdmin: boolean = false;
  public isAdmin: boolean = false;
  public isMotorrad: boolean = false;
  public isRollsRoyce: boolean = false;
  public showTakata: boolean = false;
  dropdownESeriesList = [];
  dropdownAreaList = [];
  dropdownComponentList = [];
  selectedItems = [];
  BMW?: BMWListData;
  MINI?: MINIListData;
  MOTORRAD?: MOTORRADListData;
  ROLLSROYCE?: ROLLSROYCEListData;
  prevMake?: string;
  currentMake?: string;
  makeSelected?: string;
  mouseoverLogin;

  dropdownSettingsSeries: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'seriesName',
    itemsShowLimit: 0,
    limitSelection: -1,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };

  dropdownSettingsArea: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'signalName',
    itemsShowLimit: 0,
    limitSelection: -1,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };

  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    itemsShowLimit: 0,
    limitSelection: -1,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false,

  };


  constructor(
    private cmsNavbarService: CmsNavbarService,
    private toastService: ToastConfigService,
    private adminService: AdminService,
    private modelMapService: ModelMapService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private utilityService: UtilityService,
    private spinnerService: SpinnerService,
    private scopePatternService: ScopePatternService,
    private dialogService: DialogService,
    private analyticsService: AnalyticsService
  ) { }

  getPageTitle(): string {
    this.pageTitle = (this.actionType.charAt(0).toUpperCase() + this.actionType.slice(1) + " " + "Scope Pattern Library");
    return this.pageTitle;
  }

  public onDropDownClose(item: any) {
    // FIXME method being used with no implementation
  }

  ngOnInit() {
    this.inputChannel = "undefined";
    this.scopePatternNumber = "undefined";
    this.makeSelected = "BMW";
    this.prevMake = "undefined";
    this.errorMessageSIB = '';

    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    if (APP_SETTINGS.isAdmin === 'true') {
      this.isAdmin = true;
    }
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });

    this.pageTitle = '';

    this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
      this.userEmail = userData['email'];
    });

    // this.userEmail = 'Chad.Pinson@partner.bmwgroup.com';
    this.documentNumbersList = [];
    this.seriesList = [];

    this.resetFields();
    this.getPageTitle();
    this.bulletinType = this.route.snapshot.paramMap.get('bulletinType');
    this.actionType = this.route.snapshot.paramMap.get('actionType');

    this.areaList = [];

    this.subscriptions.push(this.scopePatternService.getAllCatalogs().subscribe(data => {
        this.makeList = data;
    }));

    this.subscriptions.push(this.modelMapService.getAllSeries().subscribe(data => {
      this.seriesList = data;
      this.dropdownESeriesList = this.seriesList;
    }));

    this.subscriptions.push(this.scopePatternService.getAllSignals().subscribe(data => {
      this.areaList = data;
      this.dropdownAreaList = this.areaList;      
    }));

    this.findAllScopePatternNumberList(this.makeSelected);
    this.setRandomDocNumber();
  }

  findAllScopePatternNumberList(makeName) {

    this.spinnerService.show("bmwSpinner");
    this.findAllScopePatternNumberListRequest.makeName = makeName;
    this.subscriptions.push(this.scopePatternService.findAllScopePatternNumberList(this.findAllScopePatternNumberListRequest).subscribe(
      (data: FindAllScopePatternNumberListResponse) => {
        this.findAllScopePatternNumberListResponse = data;
        this.spinnerService.hide("bmwSpinner");
      },
      (err: ResultStatus) => {
        console.error('Error retrieving all ScopePattern number list', err);
        this.spinnerService.hide("bmwSpinner");
      },
      () => this.populateAllScopePatternNumberList()
    ));
  }

  populateAllScopePatternNumberList() {
    this.ScopePatternNumbersList = this.findAllScopePatternNumberListResponse.scopePatternNumbersList;
  }

  populateNoiseParamList() {
    if (this.scopePatternParamsRefDataResponse != null && this.scopePatternParamsRefDataResponse.status.statusCode === 'SUCCESS') {
      this.BMW = this.scopePatternParamsRefDataResponse.scopePatternDataParams.BMW;
      this.MINI = this.scopePatternParamsRefDataResponse.scopePatternDataParams.MINI;
      this.MOTORRAD = this.scopePatternParamsRefDataResponse.scopePatternDataParams.MOTORRAD;
      this.ROLLSROYCE = this.scopePatternParamsRefDataResponse.scopePatternDataParams.ROLLSROYCE;
      if (this.makeSelected === 'BMW') {
        this.findAllScopePatternNumberList(this.makeSelected);
      }
    }
  }

  populateOneScopePatternNumber() {
    this.scopePatternData = this.findOneScopePatternNumberResponse.scopePatternData;
    this.textareaContent = this.scopePatternData.scopePatternTitle;
    this.isDocActive = this.scopePatternData.isActive;
    this.seriesFilterList = filterSeriesArray(this.seriesList, this.scopePatternData.series);
    this.areaFilterList = this.scopePatternData.signals;
    this.splDocumentName = this.scopePatternData.splDocumentName;
    setTimeout(() => {
      this.selDate = this.scopePatternData.releaseDate;
      this.inputDate = this.scopePatternData.releaseDate;
    }, 50)
    this.spinnerService.hide("bmwSpinner");
  }
  
  // functions for edit
  getScopePatternData(scopePatternNumber, makeName) {
    if (makeName === null || scopePatternNumber === null)
      return;
    this.spinnerService.show("bmwSpinner");
    this.selDate = '';
    this.inputDate = '';
    this.findOneScopePatternNumberRequest.makeName = makeName;
    this.findOneScopePatternNumberRequest.docNumber = scopePatternNumber;

    const results = this.findAllScopePatternNumberListResponse.scopePatternNumbersList.filter(obj => {
      return obj.scopePatternDisplayNumber === scopePatternNumber;
    });
  
    this.subscriptions.push(this.scopePatternService.findOneScopePatternNumber(results[0].scopePatternId).subscribe(
      (data: FindOneScopePatternNumberResponse) => {
        this.findOneScopePatternNumberResponse = data;
        this.showAllFields = true;
        this.spinnerService.hide("bmwSpinner");
      },
      (err: ResultStatus) => {
        this.spinnerService.hide("bmwSpinner");
        if (err !== null && err.statusCode === 'FAILURE') {
          this.errorMessage = err.errorDetails;
        }
        console.error('Error finding ScopePattern number', err);
      },
      () => this.populateOneScopePatternNumber()
    ));
  }

  onMakeSelectionChanged(event) {

    if (this.makeSelected != "undefined" && this.prevMake != event) {
      if (this.dialogService.confirm('Changing the Make will reset the form entries, all entries will be lost. \n Do you want to continue? ')['value'] === true) {
        this.makeSelected = event;
        this.prevMake = event;
        this.changeMaingroupList(this.makeSelected);
        this.populateNoiseParamListByMake(this.makeSelected);
        this.showAllFields = false;
      }
      else {
        this.makeSelected = this.prevMake;
      }
    }
    if (this.makeSelected == "undefined" && event != "undefined") {
      this.makeSelected = event;
      this.prevMake = event;
      this.changeMaingroupList(this.makeSelected);
    }
    this.findAllScopePatternNumberList(event);
    return this.prevMake;
  }
  changeMaingroupList(makeNameCurrent){
    this.subscriptions.push(this.cmsNavbarService.getMainGroupsListbyMakeName(makeNameCurrent).subscribe(data => {
      this.channelsList = data;
    }));
  }

  populateNoiseParamListByMake(makeNameCurrent) {

    this.resetFields();
    if (makeNameCurrent === 'BMW') {
      this.inputMake = 'BMW';
      //this.dropdownAreaList = this.areaList;
    }
    else if (makeNameCurrent === 'MINI') {
      this.inputMake = 'MINI';
      //this.dropdownAreaList = this.areaList;
    }
    
  }

  resetFields() {
    //this.inputMake = null;
    this.seriesFilterList = [];
    this.relatedSIBs = [];
    this.uploadedFile = this.inputDate = '';
    this.uploadedFileName = 'No File Selected';
    this.vimeoID = '';
    this.bulletinNumber = this.documentNumber = this.textareaContent = this.tkrCode = '';
    this.isTakataRecall = false;
    this.newUploadFlag = false;
    this.documentNumber = null;
    //this.makeNameForApi = undefined;

    //this.areaList = [];
    //this.dropdownAreaList = [];
    this.areaFilterList = [];

    this.dropdownComponentList = [];
    
    this.inputChannel = "undefined";
    this.scopePatternNumber = "undefined";
  }

  addToSelection(listType: string, listItem: string | object) {
    listItem = listItem !== null && typeof listItem === 'object' ? listItem['engineName'] : listItem;
    if (listItem) {
      switch (listType) {
        case 'sib':
          this.bulletinNumber = '';
          this.addNewBulletin(this.makeSelected, listItem);
          break;
      }
    }
  }

  addNewBulletin(makeSelected, bulletinNumber) {
    this.errorMessageSIB = '';
    if (bulletinNumber) {
      const bulletinId = bulletinNumber.replace(/\s+/g, "");
      this.adminService.findBulletinByNumberMake(bulletinId, makeSelected).subscribe(
        () => {

          this.relatedSIBs.push(bulletinNumber);
        },
        error => {
          console.error('Error searching bulleting by NumberMake', error);
          this.errorMessageSIB = 'Please enter valid active SIB.';
        });
    }
  }

  removeFromSelection(listType: string, listItem: string) {
    switch (listType) {
      case 'sib':
        this.relatedSIBs = this.relatedSIBs.filter(item => item !== listItem);
        break;
    }
  }
  removeFromNoiseSelection(listType: any, listItem: any) {
    switch (listType) {

      case 'series':
        this.seriesFilterList = this.seriesFilterList.filter(item => item !== listItem.seriesName);
        break;
      case 'area':
        this.areaFilterList = this.areaFilterList.filter(item => item !== listItem);
        break;
    }
  }
  addToNoiseSelection() {
    // FIXME Method being used with no implementation
  }

  fileUpload(fileObj) {
    if (fileObj && fileObj.target.files.length > 0) {
      const file = fileObj.target.files[0];
      const isFileValid = this.utilityService.fileValidator(file.name);
      if (!isFileValid) {
        this.errorMessage = 'File type not supported';
        this.uploadedFile = null;
        this.uploadedFileName = '';
      } else {
        this.errorMessage = '';
        this.uploadedFile = file;
        this.uploadedFileName = file.name;
        this.newUploadFlag = true;
      }
    }
  }

  onSubmit(form: NgForm) {
    
    const selectedSeries = filterSeriesArray(this.seriesList, this.seriesFilterList);
    if(this.documentNumber === '' || 
      this.textareaContent === '' || 
      this.inputDate === '' ||
      selectedSeries.length === 0 ||
      this.areaFilterList.length === 0 ||
      this.splDocumentName === '') {
        this.errorMessage = 'All the required (*) fields must be filled before submit';
    } else if (form.valid) {
      this.submit(form);
    }
        
  }

  submit(form: NgForm) {
    if (this.inputDate == null) {
      this.inputDate = this.setDefaultDate();
    }
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }
    
    //Trilok Start
    if (this.actionType === 'edit') {
      // this.spinnerService.show("bmwSpinner");
      if (this.bulletinType === 'scope pattern library') {
        const selectedSeries = filterSeriesArray(this.seriesList, this.seriesFilterList);
        //const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
        const selectedMake = this.makeList.filter(obj => {
          return obj.makeName === this.makeSelected;
        });
        
        const noiseObject = {      
          id: this.scopePatternData.scopePatternId,
          scopePatternDisplayNumber: this.scopePatternData.scopePatternDisplayNumber,
          scopePatternTitle: this.textareaContent,
          make: selectedMake[0],
          //mainGroup: this.inputChannel,
          releaseDate: this.inputDate,
          splDocumentName: (this.uploadedFileName.length > 0) ? this.uploadedFileName.length : this.scopePatternData.splDocumentName,
          isActive: !this.deactivate,
          deactivateComments: this.deactivate ? "Deactivated by " + this.userEmail + " at " + this.setDefaultDate() : "",
          createdTs: this.setDefaultDate(),
          updatedTs: this.setDefaultDate(),
          series: selectedSeries,
          signals: this.areaFilterList,       
        };
        this.spinnerService.show("bmwSpinner");
        this.subscriptions.push(this.adminService.updateScopePattern(noiseObject).subscribe(value => {
          if (value) {
            if (this.uploadedFileName !== 'No File Selected' && this.uploadedFileName.length > 0) {
              this.spinnerService.show("bmwSpinner");
              const formData = new FormData();
              formData.append('documentFile', this.uploadedFile, this.uploadedFile.name);
              this.subscriptions.push(this.adminService.updateScopePatternWithFile(formData, this.scopePatternData.scopePatternId)
                .subscribe(data => {
                  if (data) {
                    this.spinnerService.hide("bmwSpinner");
                    this.toastService.popToast('Scope Pattern added');
                    this.errorMessage = '';
                    this.errorMessageSIB = '';
                    this.inputSeries = '';
                    this.inputArea = '';
                    this.inputChannel = "undefined";
                    this.makeSelected = "undefined";
                    this.prevMake = 'undefined';
                    this.errorMessage = '';
                    this.resetFields();
                  }
                },
                  error => {
                    this.spinnerService.hide("bmwSpinner");
                    this.errorMessage = error.error.message;
                  }));
            } else {

              this.spinnerService.hide("bmwSpinner");
              this.resetFields();

              this.toastService.popToast('ScopePattern Updated');
              this.inputChannel = null;
              this.uploadedFile = null;

              this.errorMessage = '';
              this.errorMessageSIB = '';
              this.inputSeries = '';
              this.inputArea = '';

              this.errorMessage = '';

              this.reactivate = false;
              this.deactivate = false;
              this.showAllFields = false;

              this.inputChannel = "undefined";
              this.scopePatternNumber = "undefined";
              //this.makeSelected = "undefined";
              //this.prevMake = "undefined";
            }
                  
            if (this.reactivate === true) {
                  this.toastService.popToast('ScopePattern Reactivated');
                  //this.spinnerService.hide("bmwSpinner");
            }
            else if (this.deactivate === true) {
                  this.toastService.popToast('ScopePattern Deactivated');
                  //this.spinnerService.hide("bmwSpinner");
            }
          }
        }));
      }
    }

    this.analyticCallScopePatternUpdated();
  }
  
  analyticCallScopePatternUpdated() {
    let userID = this.authService.getUserName();
    this.analyticsService.trackEditContentUpdated(userID, "Noise Catalog", this.makeSelected, this.scopePatternNumber, 'updated');
  }

  public setReactivate(event: any): void {
    // FIXME method being used with no implementation
  }

  public setDeactivate(event: any): void {
    // FIXME method being used with no implementation
  }

  setRandomDocNumber() {
    if (this.bulletinType == "obd") {
      this.documentNumber = "OD" + Math.floor(100000 + Math.random() * 900000);
      return this.documentNumber;
    } else {
      return '';
    }
  }

  formatBulletinNumber(event: any, sibOrVideo: string) {
    if (event.key == "ArrowLeft" || event.key == "ArrowRight" || event.keyCode == 8 || event.keyCode == 65 || event.keyCode == 67 || event.keyCode == 17) { return };
    let tempInput;
    let split = 2;
    let chunk = [];
    // tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");

    if (sibOrVideo === 'sib') {
      tempInput = this.bulletinNumber;
      tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");
      for (let i = 0; i < this.bulletinNumber.length; i += split) {
        chunk.push(tempInput.substr(i, split));
      }
      tempInput = chunk.join(' ').trim();
      this.bulletinNumber = tempInput.slice(0, 8);
    }
    else if (sibOrVideo === 'noise catalog') {
      tempInput = this.documentNumber;
      tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");
      for (let i = 0; i < this.documentNumber.length; i += split) {
        chunk.push(tempInput.substr(i, split));
      }
      tempInput = chunk.join(' ').trim();
      this.documentNumber = tempInput.slice(0, 8);
    }
  }

  setDefaultDate(): string {
    let d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe());
  }

}

function filterSeriesArray(array, filter) {
  var myArrayFiltered = [];
  for (var i = 0; i < array.length; i++) {
    for (var j = 0; j < filter.length; j++) {
      if (array[i].id === filter[j].id && array[i].seriesName === filter[j].seriesName) {
        myArrayFiltered.push(array[i]);
      }
    }
  }
  return myArrayFiltered;
}
